import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-btn',
  templateUrl: './export-btn.component.html',
  styleUrls: ['./export-btn.component.scss']
})
export class ExportBtnComponent  {
  @Input() label = 'Export'
  @Input() disabled = false;
  @Input() isLoading = false;
}
